import { createSlice } from "@reduxjs/toolkit";
import { getCookie, setCookie } from "@Src/utils/cookie.utils";
import { LANGUAGE_COOKIE } from "@Src/constants";

const value = getCookie(LANGUAGE_COOKIE);

export const initialState = {
  language: value || "",
};

const languageSlice = createSlice({
  name: "language",
  initialState: initialState,
  reducers: {
    updateLanguage: (state, action) => {
      const { language } = action.payload;
      setCookie(LANGUAGE_COOKIE, language, 2 * 365);
      state.language = language;
    },
  },
});

export const actions = languageSlice.actions;

export default languageSlice.reducer;
